module.exports = __webpack_public_path__ + "static/images/fa-light-300.32f7692.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-light-300.svg
// module id = 7gbC
// module chunks = 12